import React, { useRef, useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import SelectSearchParty from "../AdminSearchExpense/SelectSearchParty";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { ApiUrl } from "../../../ApiUrl";

const AdmAttendanceEntry = () => {
  const navigate = useNavigate();
  const [selectedDate, setSelectedDate] = useState(
  new Date().toISOString().split("T")[0]
);
  const [communicationDetails, setCommunicationDetails] = useState("");
  const [students, setStudents] = useState([]);
  const maxCharacters = 5000;
  const [mentors, setMentors] = useState([]);
  const [selectedMentor, setSelectedMentor] = useState(null);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [selectedCommunicatedWith, setSelectedCommunicatedWith] =
    useState(null);
  const [selectedCommunicatedVia, setSelectedCommunicatedVia] = useState(null);

  const dateRef = useRef(null);
  const fromClassRef = useRef(null);
  const toClassRef = useRef(null);
  const admissionNoRef = useRef(null);
  const barcodeRef = useRef(null);
  const smsToRef = useRef(null);

  const handleClear = () => {
  setSelectedDate(new Date().toISOString().split("T")[0]);
  setSelectedMentor(null);
  setSelectedStudent(null);
  setSelectedCommunicatedWith(null);
  setSelectedCommunicatedVia(null);
  setCommunicationDetails("");
};
  useEffect(() => {
    const fetchMentors = async () => {
      try {
        const response = await fetch(
          `${ApiUrl.apiurl}Teacher/GetEmployeeList/?orgId=1&branchId=1`
        );
        const data = await response.json();
        if (data && data.data) {
          // Mapping data to match React Select options format
          const formattedMentors = data.data.map((mentor) => ({
            value: mentor.id,
            label: mentor.employeeName,
          }));
          setMentors(formattedMentors);
        }
      } catch (error) {
        console.error("Error fetching mentors:", error);
      }
    };

    fetchMentors();
  }, []);

  const branchId = localStorage.getItem("branchId");
  const orgId = localStorage.getItem("orgId");
  const academicYearId = localStorage.getItem("academicSessionId");

  useEffect(() => {
    if (!selectedMentor) return;

    const fetchStudents = async () => {
      try {
        const url = `${ApiUrl.apiurl}Mentor/mentorWiseStudentList/?academic_year_id=${academicYearId}&org_id=${orgId}&branch_id=${branchId}&teacher_id=${selectedMentor.value}`;
        const response = await fetch(url);
        const data = await response.json();

        if (data && data.data) {
          const formattedStudents = data.data.map((student) => ({
            value: student.student_id, // Corrected key mapping
            label: student.student_name, // Corrected key mapping
          }));
          setStudents(formattedStudents);
        }
      } catch (error) {
        console.error("Error fetching students:", error);
      }
    };

    fetchStudents();
  }, [selectedMentor, academicYearId, orgId, branchId]);

  const communicatedWithOptions = [
    { value: "student", label: "Student" },
    { value: "father", label: "Father" },
    { value: "mother", label: "Mother" },
  ];

  const communicatedViaOptions = [
    { value: "phone", label: "Phone " },
    { value: "email", label: "Email" },
    { value: "in person", label: "In Person" },
  ];

  // const handleSave = async () => {
  //   if (
  //     !selectedDate ||
  //     !selectedMentor ||
  //     !selectedStudent ||
  //     !selectedCommunicatedWith ||
  //     !selectedCommunicatedVia ||
  //     !communicationDetails
  //   ) {
  //     alert("Please fill all required fields.");
  //     return;
  //   }

  //   const payload = {
  //     date: selectedDate.toISOString().split("T")[0], // Formatting date as YYYY-MM-DD
  //     teacher_id: selectedMentor.value,
  //     student_id: selectedStudent.value,
  //     communicated_with: selectedCommunicatedWith.value,
  //     communicated_via: selectedCommunicatedVia.value,
  //     remarks: communicationDetails,
  //     academic_year_id: academicYearId,
  //     org_id: orgId,
  //     branch_id: branchId,
  //   };

  //   try {
  //     const response = await fetch(
  //       `${ApiUrl.apiurl}Mentor_Student_Communication/studentMentorCommunication/`,
  //       {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //         body: JSON.stringify(payload),
  //       }
  //     );

  //     const data = await response.json();

  //     if (response.ok) {
  //       alert("Data saved successfully!");
  //       // Clear the form if needed
  //       setSelectedDate(null);
  //       setSelectedMentor(null);
  //       setSelectedStudent(null);
  //       setSelectedCommunicatedWith(null);
  //       setSelectedCommunicatedVia(null);
  //       setCommunicationDetails("");
  //     } else {
  //       alert(`Error: ${data.message || "Something went wrong!"}`);
  //     }
  //   } catch (error) {
  //     console.error("Error saving data:", error);
  //     alert("Failed to save data.");
  //   }
  // };

  const handleSave = async () => {
    if (
      !selectedDate ||
      !selectedMentor ||
      !selectedStudent ||
      !selectedCommunicatedWith ||
      !selectedCommunicatedVia ||
      !communicationDetails
    ) {
      alert("Please fill all required fields.");
      return;
    }

    // Formatting date as YYYY-MM-DD without timezone shift
    // const formattedDate = new Date(
    //   selectedDate.getTime() - selectedDate.getTimezoneOffset() * 60000
    // )
    //   .toISOString()
    //   .split("T")[0];

    const localDate = new Date(selectedDate);
    const formattedDate = new Date(
      localDate.getTime() - localDate.getTimezoneOffset() * 60000
    )
      .toISOString()
      .split("T")[0];

    const payload = {
      date: formattedDate, // Ensuring correct local date
      teacher_id: selectedMentor.value,
      student_id: selectedStudent.value,
      communicated_with: selectedCommunicatedWith.value,
      communicated_via: selectedCommunicatedVia.value,
      remarks: communicationDetails,
      academic_year_id: academicYearId,
      org_id: orgId,
      branch_id: branchId,
    };

    try {
      const response = await fetch(
        `${ApiUrl.apiurl}Mentor_Student_Communication/studentMentorCommunication/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      const data = await response.json();

      if (response.ok) {
        alert("Follow Up created successfully!");
        // Clear the form if needed
        setSelectedDate(null);
        setSelectedMentor(null);
        setSelectedStudent(null);
        setSelectedCommunicatedWith(null);
        setSelectedCommunicatedVia(null);
        setCommunicationDetails("");
      } else {
        alert(`Error: ${data.message || "Something went wrong!"}`);
      }
    } catch (error) {
      console.error("Error saving data:", error);
      alert("Failed to save data.");
    }
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="card p-0">
            <div className="card-body">
              <p
                style={{
                  marginBottom: "0px",
                  textAlign: "center",
                  fontSize: "20px",
                  fontWeight: "700",
                }}
              >
                STUDENT MENTOR
              </p>
              <div className="row mb-2 mt-3 mx-0">
                <div className="col-12 d-flex flex-wrap gap-2">
                  <button
                    type="button"
                    className="btn btn-primary me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={handleSave}
                  >
                    Save
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={handleClear}
                  >
                    Clear
                  </button>

                  <button
                    type="button"
                    className="btn btn-danger me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={() => navigate("/admin/follows-ups")}
                  >
                    Close
                  </button>
                </div>
              </div>

              <div className="row mt-3 mx-2">
                <div className="col-12 custom-section-box">
                  <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center">
                    <div className="row flex-grow-1 mt-2">
                      <div className="col-12 col-md-3 mb-4">
                        <label htmlFor="date" className="form-label">
                          Date
                        </label>
                        <input
                          type="date"
                          id="date"
                          className="form-control detail"
                          value={selectedDate}
                          onChange={(e) => setSelectedDate(e.target.value)}
                          placeholder="Select date"
                        />
                      </div>

                      <div className="col-12 col-md-3 mb-4">
                        <label htmlFor="mentor" className="form-label ">
                          Mentor
                        </label>
                        <Select
                          id="mentor"
                          options={mentors}
                          className="detail"
                          value={selectedMentor}
                          onChange={setSelectedMentor}
                          placeholder="Select Mentor"
                          classNamePrefix="mentor-dropdown"
                        />
                      </div>
                      {/* Student Dropdown (Appears only if mentor is selected) */}
                      <div className="col-12 col-md-3 mb-4">
                        <label htmlFor="student-name" className="form-label ">
                          Student Name
                        </label>
                        <Select
                          id="student-name"
                          classNamePrefix="student-name-dropdown"
                          className="flex-grow-1 detail"
                          options={students} // Dropdown values appear only after selecting a mentor
                          placeholder="Select Student"
                          isDisabled={!selectedMentor} // Disables dropdown until a mentor is selected
                          value={selectedStudent}
                          onChange={setSelectedStudent}
                        />
                      </div>
                      {/* Communicated With Dropdown */}
                      <div className="col-12 col-md-3 mb-4 ">
                        <label
                          htmlFor="communicated-with"
                          className="form-label"
                        >
                          Communicated With*
                        </label>
                        <Select
                          id="communicated-with"
                          classNamePrefix="communicated-with-dropdown"
                          className="flex-grow-1 detail"
                          options={communicatedWithOptions}
                          value={selectedCommunicatedWith}
                          onChange={setSelectedCommunicatedWith}
                          placeholder="Select "
                        />
                      </div>

                      {/* Communicated Via Dropdown */}
                      <div className="col-12 col-md-3 mb-4">
                        <label
                          htmlFor="communicated-via"
                          className="form-label "
                        >
                          Communicated Via*
                        </label>
                        <Select
                          id="communicated-via"
                          classNamePrefix="communicated-via-dropdown"
                          className="flex-grow-1 detail"
                          options={communicatedViaOptions}
                          placeholder="Select"
                          value={selectedCommunicatedVia}
                          onChange={setSelectedCommunicatedVia}
                        />
                      </div>
                      {/* Communication Details Input Field */}
                      <div className="col-12 col-md-6 mb-4 mentor-communication-details">
                        <label
                          htmlFor="communication-details"
                          className="form-label"
                        >
                          Communication Details*
                        </label>
                        <textarea
                          id="communication-details"
                          className="detail mentor-communication-textarea"
                          rows="4"
                          maxLength={maxCharacters}
                          value={communicationDetails}
                          onChange={(e) =>
                            setCommunicationDetails(e.target.value)
                          }
                        />
                        <small className="text-muted mentor-communication-counter">
                          No. of characters left:{" "}
                          {maxCharacters - communicationDetails.length}
                        </small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdmAttendanceEntry;
